import React from 'react';
import { Route, Switch, Redirect } from "react-router-dom";
import ProductList from 'components/artectum/grid/grid-portfolio';
import ProductDetail from 'components/views/project-details';

const ProductRoutes = () => (
    <Switch>
        <Route exact path="/portfolio/portfolio-list" component={ProductList} />
        <Route exact path="/portfolio/project-details/:id" component={ProductDetail} />
        <Route path="/portfolio/*">
            <Redirect to="/portfolio/portfolio-list" />
        </Route>
    </Switch>
);

export default ProductRoutes;